import { useForm, UseFormReturn } from 'react-hook-form';
import { ReportDefinition, ReportDefinitionEntity } from '../../types';

export interface UseReportDefinitionFormResult {
  form: UseFormReturn<ReportDefinition>;
}

export function useReportDefinitionForm(
  definition: ReportDefinitionEntity,
): UseReportDefinitionFormResult {
  const form = useForm<ReportDefinition>({
    defaultValues: {
      name: definition.name,
      isDefault: definition.isDefault,
      data: definition.definition,
    } as Partial<ReportDefinition>,
    mode: 'onChange',
  });

  return { form };
}
